const findColorType = (color) => {
  switch (color) {
    case 'weekday':
      return 'bg-secondary-main';
    case 'weekend':
      return 'bg-[#91C5EB]';
    case 'everyday':
      return 'bg-primary-main';
    case 'regular':
      return 'bg-[#73C8AF]';
    case 'special':
      return 'bg-[#91C5EB]';
    case 'collaboration':
      return 'bg-[#F2CA2C]';
    case 'featured':
      return 'bg-[#8E44AD]';
    case 'curated':
      return 'bg-[#4b4737]';
    case 'private':
      return 'bg-[#f05c5f]';
    default:
      return 'bg-[#F2CA2C]';
  }
};

const findValidFor = (type) => {
  switch (type) {
    case 1:
      return 'Exhibition & Play Space';
    case 2:
      return 'Exhibition Space ONLY';
    default:
      return 'Exhibition';
  }
};

const findValidForClass = (type) => {
  switch (type) {
    case 'regular':
      return 'Regular Kin Class';
    case 'special':
      return 'Special Class';
    case 'curated':
      return 'Curated Class';
    case 'featured':
      return 'Featured Class';
    case 'private':
      return 'Private Class';
    case 'collaboration':
      return 'Collaborative';
    default:
      return 'Classes';
  }
};

const getQuotaColor = (quota) => {
  if (quota >= 3) return 'text-green-600';
  if (quota === 2) return 'text-amber-500';
  return 'text-red-500';
};

const formatTitleByWord = (title = '') => {
  const words = title.trim().split(' ');
  const grouped = [];

  for (let i = 0; i < words.length; i += 2) {
    grouped.push(words.slice(i, i + 2).join(' '));
  }

  return grouped.join('\n');
};

export { findColorType, findValidFor, findValidForClass, getQuotaColor, formatTitleByWord };
